import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import React__default, { useState } from 'react';
import classNames from 'classnames';
import styles from './3fbf92b4a283f1c578008904a5cfe3bf66e7894d3f5cdf26dfebaf3c172ec984.cfe-internal.js';
import { DATA_TESTID_SUFFIXES } from './f19a86cd642a409c0d33d8b3587b52a5386dfe9bdc5ed2ccfe2189e80441545b.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/ab9ed2b21c82580ec784a93d344c77c1672a9cc3db9dc12c3175fa65e7ce419c.cfe-internal.js';
import useId from '../../hooks/useId/449a3fe82a3de04228b156fb9c192c6eb54d1aa31378ed8af87c1128d2309698.cfe-internal.js';
import { useDidUpdate } from '../../hooks/useDidUpdate/902514ef45e755459db44cc1406ebbd6e3e7419aefe5d7bc91c709499b75773f.cfe-internal.js';
import getSubDataTestId from '../../utils/getSubDataTestId/73ae9f6a35da267a1860b5c38dfe3fdef29fb119bdc7418c7684ce4bda3a2f44.cfe-internal.js';
import UnpinIcon from '../../icons/components/e1ebcdefdb0e85680de81a6852d254f0b26bccc0af38c3b921038a29c5fdd4fa.cfe-internal.js';
import PinIcon from '../../icons/components/af7848c16f823733be34ba32653ec2acee959ea5e934596cb517082d9cd6f1f5.cfe-internal.js';
import ChevronLeftIcon from '../../icons/components/269a820c42e2c98b68c510b7d0859e08efb9b78e77c75e868a11f93ef994d8c5.cfe-internal.js';
import ChevronRightIcon from '../../icons/components/7c1abc076b4bfccb2936ed1ad22a89bc68d713680237e732848398dfb69b6001.cfe-internal.js';
import useTranslation from '../../utils/Translation/47d395f30036b487ef3ded6d813eeb8887878947654c2f6624000c7005c4dd94.cfe-internal.js';
import Tooltip from '../../components/Tooltip/cf6cf009c498d67484626c4540161117b545207431106c57103cbe6ecd8eabaf.cfe-internal.js';
import IconButton from '../../components/IconButton/16387be5b1f7f8ab5852045d8dcae8abae3c2cb67b7c9e1ace6ccfd3508c8ba7.cfe-internal.js';

var ExpandCollapseButton = function ExpandCollapseButton(_ref) {
  var isOpen = _ref.isOpen,
      isTransitioning = _ref.isTransitioning,
      onClick = _ref.onClick,
      panelId = _ref.panelId,
      dataTestId = _ref['data-testid'];

  var _useTranslation = useTranslation(),
      translate = _useTranslation.translate;

  var showPanelLabel = translate('configPane.showPanel');
  var hidePanelLabel = translate('configPane.hidePanel');
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    content: isOpen ? hidePanelLabel : showPanelLabel,
    delayMs: 500,
    placement: "right",
    disabled: isTransitioning,
    lightTheme: true
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    "aria-label": isOpen ? hidePanelLabel : showPanelLabel,
    className: classNames(styles.toolbarPanelExpandCollapseButton),
    "aria-expanded": isOpen,
    "aria-controls": panelId,
    onClick: onClick,
    "data-testid": dataTestId
  }, /*#__PURE__*/React__default.createElement("span", null, isOpen ? /*#__PURE__*/React__default.createElement(ChevronLeftIcon, {
    size: "small",
    "aria-hidden": "true"
  }) : /*#__PURE__*/React__default.createElement(ChevronRightIcon, {
    size: "small",
    "aria-hidden": "true"
  }))));
};

var ConfigPane = function ConfigPane(_ref2) {
  var _classNames;

  var id = _ref2.id,
      title = _ref2.title,
      children = _ref2.children,
      _ref2$shouldShowPanel = _ref2.shouldShowPanelPreview,
      shouldShowPanelPreview = _ref2$shouldShowPanel === void 0 ? false : _ref2$shouldShowPanel,
      externalIsOpen = _ref2.isOpen,
      onIsOpenChange = _ref2.onIsOpenChange,
      externalIsPinned = _ref2.isPinned,
      onIsPinnedChange = _ref2.onIsPinnedChange,
      ariaLabel = _ref2['aria-label'],
      ariaLabelledby = _ref2['aria-labelledby'],
      ariaDescribedBy = _ref2['aria-describedby'],
      dataTestId = _ref2['data-testid'];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isTransitioning = _useState2[0],
      setIsTransitioning = _useState2[1];

  var _useControllableState = useControllableState(true, onIsOpenChange, externalIsOpen),
      _useControllableState2 = _slicedToArray(_useControllableState, 2),
      isOpen = _useControllableState2[0],
      setIsOpen = _useControllableState2[1];

  var _useControllableState3 = useControllableState(true, onIsPinnedChange, externalIsPinned),
      _useControllableState4 = _slicedToArray(_useControllableState3, 2),
      isPinned = _useControllableState4[0],
      setIsPinned = _useControllableState4[1];

  var panelId = useId(id);
  useDidUpdate(function () {
    setIsTransitioning(true);
  }, [isOpen]);

  var _useTranslation2 = useTranslation(),
      translate = _useTranslation2.translate;

  var pinPanelLabel = translate('configPane.pinPanel');
  var unpinPanelLabel = translate('configPane.unpinPanel');

  var toggleOpen = function toggleOpen() {
    return setIsOpen(function (currentIsOpen) {
      return !currentIsOpen;
    });
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.paneContainer, (_classNames = {}, _defineProperty(_classNames, styles.hidden, !isOpen), _defineProperty(_classNames, styles.unpinned, !isPinned), _defineProperty(_classNames, styles.transitioning, isTransitioning), _defineProperty(_classNames, styles.preview, shouldShowPanelPreview), _classNames)),
    onTransitionEnd: function onTransitionEnd() {
      return setIsTransitioning(false);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.spacer
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.paneContentContainer,
    onClick: shouldShowPanelPreview && !isOpen ? toggleOpen : undefined
  }, /*#__PURE__*/React__default.createElement("aside", {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedBy,
    "data-testid": dataTestId,
    id: panelId,
    className: styles.paneContent
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.paneContentInner
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.title,
    "data-testid": getSubDataTestId(dataTestId, DATA_TESTID_SUFFIXES.TITLE)
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: styles.pinButton
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    content: isPinned ? unpinPanelLabel : pinPanelLabel,
    delayMs: 500,
    lightTheme: true,
    "aria-hidden": true
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    "aria-label": isPinned ? unpinPanelLabel : pinPanelLabel,
    onClick: function onClick() {
      return setIsPinned(function (currentIsPinned) {
        return !currentIsPinned;
      });
    },
    "data-testid": getSubDataTestId(dataTestId, DATA_TESTID_SUFFIXES.PIN_UNPIN_BUTTON)
  }, isPinned ? /*#__PURE__*/React__default.createElement(UnpinIcon, null) : /*#__PURE__*/React__default.createElement(PinIcon, null))))), /*#__PURE__*/React__default.createElement("div", {
    className: styles.body,
    "data-testid": getSubDataTestId(dataTestId, DATA_TESTID_SUFFIXES.BODY)
  }, children)))), /*#__PURE__*/React__default.createElement("div", {
    className: styles.clickableArea,
    onClick: toggleOpen
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.hoverBorder
  }), /*#__PURE__*/React__default.createElement(ExpandCollapseButton, {
    isOpen: isOpen,
    onClick: toggleOpen,
    isTransitioning: isTransitioning,
    "data-testid": getSubDataTestId(dataTestId, DATA_TESTID_SUFFIXES.EXPAND_COLLAPSE_BUTTON),
    panelId: panelId
  })));
};

export { ConfigPane };
